import { createContext, useState, useEffect, useContext } from "react";
import type { ReactNode } from "react";
import type { TrackObject } from "../types/tracksType";
import usePlaybackStore from "../store/playbackStore";
import { useLocation } from "react-router-dom";

type SearchContextType = {
  query: string;
  setQuery: React.Dispatch<React.SetStateAction<string>>;
  searchResults: TrackObject[];
  setSearchResults: React.Dispatch<React.SetStateAction<TrackObject[]>>;
  isSearchLoading: boolean;
  setIsSearchLoading: React.Dispatch<React.SetStateAction<boolean>>;
  hasSearchError: boolean;
  setHasSearchError: React.Dispatch<React.SetStateAction<boolean>>;
};

type SearchContextProviderProps = {
  children: ReactNode;
};

const SearchContext = createContext<SearchContextType | null>(null);

export const SearchProvider = ({ children }: SearchContextProviderProps) => {
  const [query, setQuery] = useState("");
  const [searchResults, setSearchResults] = useState<TrackObject[]>([]);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [hasSearchError, setHasSearchError] = useState(false);
  const setQueue = usePlaybackStore.getState().setQueue;
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/search") return;

    setQueue(searchResults);
  }, [searchResults, location.pathname]);

  return (
    <SearchContext.Provider
      value={{ query, setQuery, searchResults, setSearchResults, isSearchLoading, setIsSearchLoading, hasSearchError, setHasSearchError }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearchContext = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error("useSearchContextはSearchProvider内で使用する必要があります");
  }
  return context;
};
